<div class="leaderboard-section">
    <app-leaderboard [length]="10"></app-leaderboard>
</div>
